<template>
  <Slide @mousemove.native="handleMouseMove">
    <Grid slideTag="obsession" @animationCallbackReady="(callback) => $emit('animationCallbackReady', callback)">
      <h2 class="heading typ__size_lg typ__leading_loose" slot="col-1">Today, I'm working on my <em class="typ__style_bold">{{skill || getRandomSkill()}}</em>.</h2>
      <p class="typ__size_md paragraph-indent" slot="col-2">I am obsessed with learning.</p>
      <p class="typ__size_md paragraph-indent" slot="col-2">I spend my waking hours reading about new technologies and different development techniques. The rest of the time I'm on my editor.</p>
      <p class="typ__size_md paragraph-indent" slot="col-2">And I am obsessed with details.</p>
      <p class="typ__size_md paragraph-indent" slot="col-2">I worry no less over every pixel than any designer – or any developer over every line of code.</p>
    </Grid>
  </Slide>
</template>

<script>
import Slide from '@/components/Slide.vue'
import Grid from '@/components/Grid.vue'
import throttle from 'lodash.throttle'

export default {
  name: 'ObsessionSlide',
  components: {
    Slide,
    Grid
  },
  data: function () {
    return {
      skills: [
        'HTML',
        'CSS',
        'JavaScript',
        'MySQL',
        'Java',
        'Python',
        'React',
        'Vue',
        'Polymer',
        'Redux',
        'WordPress',
        'Unix shell',
        'Git',
        'design patterns',
        'web tooling',
        'graphic design',
        'layout design',
        'responsive web design',
        'OOP',
        'front end optimization',
        'front-end',
        'semantic markup',
        'keyboard shortcuts',
        'software development',
        'user interface design',
        'Ruby',
        'Rails',
        'Go',
        'TypeScript',
        'problem solving',
        'MongoDB',
        'functional programming',
        'API design'
      ],
      skill: null,
      header: null,
      footer: null
    }
  },
  methods: {
    getRandomSkill: function () {
      const randomIndex = Math.floor(Math.random() * this.skills.length)

      return this.skills[randomIndex]
    },
    handleMouseMove: throttle(function (e) {
      this.skill = this.getRandomSkill()
    }, 150),
    attachEventListeners: function (e) {
      this.header.addEventListener('mousemove', this.handleMouseMove)
      this.footer.addEventListener('mousemove', this.handleMouseMove)
    }
  },
  mounted: function () {
    this.header = document.querySelector('.site-header')
    this.footer = document.querySelector('.site-footer')

    if (this.$route.hash === '#obsession') {
      this.attachEventListeners()
    }
  },
  watch: {
    '$route.hash': function (newHash, oldHash) {
      if (newHash === '#obsession') {
        this.attachEventListeners()
      } else {
        this.header.removeEventListener('mousemove', this.handleMouseMove)
        this.footer.removeEventListener('mousemove', this.handleMouseMove)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.heading {
  width: 90%;
  margin-bottom: 0;
}

@include md-screen {
  .heading {
    position: relative;
    top: -.38em;
  }
}
</style>
